import { SpyneTrait, ViewStream, SpyneAppProperties } from "spyne";
import { UtilTraits } from "traits/util-traits";
import sdk from "@stackblitz/sdk";

export class CodePlaygroundExamplesTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "codePlaygroundExamples$";

    super(context, traitPrefix);
  }

  static codePlaygroundExamples$UtilSendStyleUpdate(payload) {
    const channel = "CHANNEL_CODE_CONTAINER";
    const action = "CHANNEL_CODE_CONTAINER_STYLE_UPDATE_REQUEST_EVENT";

    this.sendInfoToChannel(channel, payload, action);
  }

  static codePlaygroundExamples$UtilUpdateDefineHeight(codeElHeight, parentElHeight) {

 //console.log("UPDATE HEIGHT", {codeElHeight, parentElHeight})
    UtilTraits.util$AdjustElHeight(this.props.el, codeElHeight);
    const { parentVsid } = this.props;
    const iframeHeight = codeElHeight;
    const payload = {
      iframeHeight,
      styleType: "height",
      styleKey: "height",
      styleVal: `${parentElHeight}px`,
      parentVsid,
    };

    const resendUpdate = ()=>{
      if (this?.props?.el) {
        const parentEl = this?.props?.el?.parentElement?.parentElement;
        const parentUpdateHeight = parseInt(codeElHeight) +
            parentEl?.querySelector(
                ".code-container-details-text")?.offsetHeight + 80;
        payload.styleVal = `${parentUpdateHeight}px`;
        this.codePlaygroundExamples$UtilSendStyleUpdate(payload);
      }

    }
    window.setTimeout(resendUpdate, 500);


    this.codePlaygroundExamples$UtilSendStyleUpdate(payload);
/*    console.log(
      "NESTING PARENT HEIGHT 3 ",
      this.props.el.parentElement.style.height,
    );*/
  }

  static codePlaygroundExamples$HelloWorld() {
    return "Hello World";
  }

  static codePlaygroundExamples$ViewStreamInstance() {
    const props = {
      tagName: "h1",
      style: "font-family:sans-serif;",
      data: "Hello World",
    };
    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    return `    const props = {
      tagName: "h1",
      style: "font-family:sans-serif;",
      data:    "Hello World"
    }
    
    new ViewStream(props).appendToDom(document.body);
      `;
  }

  static codePlaygroundExamples$ViewStreamImgInstance() {
    const props = {
      tagName: "img",
      width: "350px",
      src: "https://holdrr.com/s/moon.jpg",
    };

    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    return `    const props = {
      tagName: "img",
      width: "350px",
      src:     "https://holdrr.com/s/moon.jpg"
    }
    
    new ViewStream(props).appendToDom(document.body);
      `;
  }

  static codePlaygroundExamples$ViewStreamImgInstance2() {
    const props = {
      tagName: "img",
      width: "350px",
      src: "https://holdrr.com/s/moon.jpg",
      style: "border:2px solid blue;",
    };

    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    return props;
  }
  static codePlaygroundExamples$ViewStreamAppendExample() {
    const vs = new ViewStream({
      style: "font-family:sans-serif;",
      data: "Hello World",
    });
    vs.appendToDom(this.props.el.contentDocument.body);

    const imgVs = new ViewStream({
      tagName: "img",
      width: "350px",
      src: "https://holdrr.com/s/moon.jpg",
    });

    vs.appendView(imgVs);

    return `
        const helloWorld = new ViewStream({
          style:   "font-family:sans-serif;",
          data:    "Hello World"
       });
       
    
        const worldImage = new ViewStream({
          tagName: "img",
          width:   "350px",
          src:     "https://holdrr.com/s/moon.jpg"
        })
    
        helloWorld.appendToDom(document.body);
        helloWorld.appendView(worldImage);
    `;
  }

  static codePlaygroundExamples$ViewStreamExampleNesting() {
    const props = {
      tagName: "iframe",
      width: "100%",
    };
    //const iframeUrl = "../../../static/iframes/example-nesting/index.html";
    const iframeUrl = UtilTraits.util$GetIframeUrl(
      "example-nesting/index.html",
    );

    const loadOnFrame = () => {
      this.props.el.src = iframeUrl;
      //UtilTraits.util$AdjustElHeight(this.props.el, 620);
      //const {parentVsid} = this.props;
      //const payload = {styleType: 'height', styleKey: 'height', styleVal: '800px', parentVsid}
      //this.codePlaygroundExamples$UtilSendStyleUpdate(payload);
      this.props.el.style.height = "521px";

      this.codePlaygroundExamples$UtilUpdateDefineHeight(620, 700);
    };

    this.props.el.style.height = "521px";

/*    console.log(
      "NESTING PARENT HEIGHT 1 ",
      this.props.el.parentElement.style.height,
    );*/

    requestAnimationFrame(loadOnFrame);

    return [
      {
        tabName: "NestingStage",
        scriptString: 	`    import { ViewStream } from 'spyne';
	import { NestingTraits } from 'traits/nesting-traits.js';
	
	export class NestingStage extends ViewStream {
	  constructor(props = {}) {
		props.id = 'nesting-example';
		props.vsid = 'reset';
		props.traits = [NestingTraits];
		props.childTypeArr = [
		  'page',
		  'section',
		  'component',
		  'widget',
		  'element',
		  'cta',
		];
		props.addRandom = true;
	
		// A small heading for context, plus the reset button
		props.template = \`
	<div class="title-bar">
	  <button class="btn reset" data-reset="true" data-add-random="false" 
			  data-child-type="reset" data-event-type="reset">
		<span class="material-symbols-outlined">&#xE5D5</span>
	  </button>
	</div>
	\`;
	
		super(props);
	  }
	
	  addActionListeners() {
		return [
		  // When user clicks the .reset button, call nestPlayground$AddwebsiteNode
		  // (thus triggering a reset).
		  ['CHANNEL_UI_CLICK_EVENT', 'nestPlayground$AddwebsiteNode', '.reset'],
		];
	  }
	
	  broadcastEvents() {
		// Broadcasting the click on .reset to CHANNEL_UI so we can respond in addActionListeners.
		return [['.reset', 'click']];
	  }
	
	  /**
	   * We immediately add a top-level “website” node, along with random children,
	   * to kick off the nesting demo.
	   */
	  onRendered() {
		this.nestPlayground$AddwebsiteNode();
		this.addChannel('CHANNEL_UI');
	  }
	}`
      },
      {
        tabName: "NestingTraits",
        scriptString: `	import { SpyneTrait } from 'spyne';
	import { NestingChildView } from 'components/nesting-child-view.js';
	
	/**
	 * Manages creation and disposal of nested ViewStream instances (e.g., website → page → section).
	 * Includes randomization logic to automatically add multiple children upon load/reset.
	 */
	export class NestingTraits extends SpyneTrait {
	  constructor(context) {
		let traitPrefix = 'nestPlayground$';
		super(context, traitPrefix);
	  }
	
	  /**
	   * Handles "nesting event" actions: 'reset' or 'add' / 'remove'.
	   * If eventType is 'reset' on the top-level (e.g., 'website'), we dispose.
	   * Otherwise, we either add a child or remove this instance.
	   */
	  static nestPlayground$OnNestingEvent(e, props = this.props) {
		// Turn off "addRandom" unless user specifically wants more random additions
		props.addRandom = false;
	
		const { eventType } = e.payload;
	
		if (eventType === 'reset') {
		  // If top-level, remove the entire nested structure
		  if (this.props.data.childType === 'website') {
			this.disposeViewStream();
		  }
		  return;
		}
	
		// For 'add' or 'remove' event
		return eventType === 'add'
		  ? this.nestPlayground$AddChild()
		  : this.disposeViewStream();
	  }
	
	  /**
	   * Adds one child to this instance.
	   * - childTypeArr is a queue of possible child types (shifted from the front).
	   * - The next child is appended into '.children' within the current DOM element.
	   */
	  static nestPlayground$AddChild(props = this.props) {
		const { addRandom } = props;
		const childTypeArr = props.childTypeArr.slice(); // copy array to avoid mutation
	
		const data = {
		  childType: childTypeArr.shift(), // pick next child type
		  addRandom,
		};
	
		this.appendView(
		  new NestingChildView({ data, childTypeArr, addRandom }),
		  '.children',
		);
	  }
	
	  /**
	   * Creates a new top-level "website" node with random additions (if needed).
	   * Typically invoked to start the nesting chain.
	   */
	  static nestPlayground$AddwebsiteNode() {
		this.appendView(
		  new NestingChildView({
			addRandom: true,
		  }),
		);
	  }
	
	  /**
	   * Weighted random logic to decide how many times to add another child.
	   * e.g., if childType= "page", we might add 2 or 3 children more frequently.
	   */
	  static nestPlayground$GetRandomAddCount(
		childType = this.props.data.childType,
	  ) {
		const ranWeightHash = {
		  website: [1], // Often add 2 children
		  page: [1, 1, 1, 2, 2, 3], // Possibly add 1-3 children, with 2 being common
		  section: [1, 1, 2, 2],
		  component: [1, 1, 1, 2],
		  ggc1: [1, 1, 1, 0],
		  widget: [1, 1, 0, 0],
		};
	
		const defaultWeight = [1, 0]; // Fallback to either 1 or 0 children
	
		const weights = ranWeightHash[childType] ?? defaultWeight;
	
		// Randomly pick an index in weights
		const index = Math.floor(Math.random() * weights.length);
		// The value at that index indicates how many times to add a child
		return weights[index];
	  }
	
	  /**
	   * If addRandom is true, pick a random number (timesToRun) from nestPlayground$GetRandomAddCount
	   * and repeatedly call nestPlayground$AddChild.
	   * This can lead to quickly building deep or wide nested structures.
	   */
	  static nestPlayground$RandomAddChildCheck(props = this.props) {
		const { addRandom } = props;
		if (!addRandom) return;
	
		if (props.addRandom === true && this.props.childTypeArr.length > 0) {
		  const timesToRun = this.nestPlayground$GetRandomAddCount();
		  for (let i = 0; i < timesToRun; i++) {
			this.nestPlayground$AddChild();
		  }
		}
	  }
	}
	`,
      },
      {
        tabName: "NestingChildView",
        scriptString: `	import { ViewStream, ChannelPayloadFilter } from 'spyne';
	import { NestingTraits } from 'traits/nesting-traits.js';
	import NestingChildTmpl from './templates/nesting-child.tmpl.html';
	
	/**
	 * Each NestingChildView represents one level (website, page, component, etc.)
	 * in the nested ViewStream hierarchy. It:
	 *  - Applies NestingTraits for add/remove logic.
	 *  - Filters UI click events so only buttons belonging to this instance (or reset) trigger actions.
	 *  - Potentially adds random sub-children upon render if addRandom is true.
	 */
	export class NestingChildView extends ViewStream {
	  constructor(props = {}) {
		// Attach NestingTraits (logic to add or remove children, handle random branching, etc.)
		props.traits = [NestingTraits];
	
		// Provide default data in case none was passed
		props.data ??= { childType: 'website' };
		// Whether to add random sub-children automatically
		props.addRandom ??= false;
		// The queue of possible child types to nest further
		props.childTypeArr ??= [
		  'page',
		  'section',
		  'component',
		  'widget',
		  'element',
		  'cta',
		];
	
		// Use a CSS class reflecting the child's type, e.g. "branch website"
		props.class = &#x60;branch \${props.data.childType}&#x60;;
	
		// The HTML template used by SpyneJS to render controls, child area, etc.
		props.template = NestingChildTmpl;
	
		// Listens to UI Channel click events
		props.channels = ['CHANNEL_UI'];
		super(props);
	  }
	
	  /**
	   * Adds an action listener that only fires if:
	   *  - The payload has a 'childType' matching this instance's childType or 'reset'
	   *  - The source element is either the same vsid or the #nesting-example
	   *
	   * This ensures that random / reset actions don't inadvertently affect unrelated nodes.
	   */
	  addActionListeners() {
		const payloadFilter = new ChannelPayloadFilter({
		  payload: (p) =&gt;
			p.childType === this.props.data.childType || p.childType === 'reset',
		  srcElement: (p) =&gt;
			p.vsid === this.props.vsid || p.id === 'nesting-example',
		});
		return [
		  [
			'CHANNEL_UI_CLICK_EVENT',
			'nestPlayground$OnNestingEvent',
			payloadFilter,
		  ],
		];
	  }
	
	  /**
	   * Tells SpyneJS which DOM events (clicks on &lt;button&gt;) to broadcast to CHANNEL_UI.
	   * This pairs with addActionListeners() to trigger the nest or dispose logic.
	   */
	  broadcastEvents() {
		return [['button', 'click']];
	  }
	
	  /**
	   * After the DOM is rendered, subscribe to CHANNEL_UI and possibly add random sub-children
	   * based on the weighting logic in NestingTraits.
	   */
	  onRendered() {
		this.nestPlayground$RandomAddChildCheck();
		if (this.props.data.childType === 'website') {
		  this.appendViewAfter(
			new ViewStream({ class: 'ui-element', data: 'header' }),
			'p',
		  );
		  this.appendViewAfter(
			new ViewStream({ class: 'ui-element', data: 'footer' }),
			'.children',
		  );
		}
	  }
	}`,
      },
      {
        tabName: "NestingChildTmpl",
        scriptType: "html",
        scriptString:  `&lt;!--
  This template is used by NestingChildView to display:
    1) The current 'childType' (e.g., website, page).
    2) Two buttons to remove or add another nested child of that same type.
    3) A '.children' container where subchildren (further nested elements) are appended.
--&gt;
&lt;p&gt;{{childType}}&lt;/p&gt;

&lt;div class="controls"&gt;
  &lt;!-- The 'remove' button triggers a remove event for this childType --&gt;
  &lt;button
    class="btn material-symbols-outlined"
    data-add-random="false"
    data-child-type="{{childType}}"
    data-event-type="remove"
  &gt;&amp;#xE15B
  &lt;/button&gt;

  &lt;!-- The 'add' button triggers an add event for this childType --&gt;
  &lt;button
    class="btn material-symbols-outlined"
    data-add-random="false"
    data-child-type="{{childType}}"
    data-event-type="add"
  &gt;&amp;#xE145
  &lt;/button&gt;
&lt;/div&gt;

&lt;!-- Subchildren will be appended here by SpyneJS when the user clicks "add" --&gt;
&lt;div class="children"&gt;&lt;/div&gt;
`,
      },
    ];
  }

  static codePlaygroundExamples$ViewStreamExampleSac() {
    const props = {
      tagName: "iframe",
      width: "100%",
    };
    // const iframeUrl = "../../../static/iframes/example-sac/index.html?change=home";
    // const iframeUrl2 = `${SpyneAppProperties.getProp('IFRAMES_PATH')}example-sac/index.html?change=home`;

    const iframeUrl = UtilTraits.util$GetIframeUrl(
      "example-sac/index.html?change=home",
    );

    const loadOnFrame = () => {
      this.props.el.src = iframeUrl;
      this.codePlaygroundExamples$UtilUpdateDefineHeight(520, 620);
    };
    requestAnimationFrame(loadOnFrame);

    return [
      {
        tabName: "AppView",

        scriptString: `  import { ViewStream } from 'spyne';
  import { PageTraits } from 'traits/page-traits.js';
  import AppTmplHTML from 'components/templates/static-example.tmpl.html';
  
  export class AppView extends ViewStream {
    constructor(props = {}) {
      // root element
      props.tagName = 'main';
      props.id = 'app';
  
      // data from PageTraits
      props.data = PageTraits.pageTraits$GetPageData();
      props.template = AppTmplHTML;
  
      props.traits = [PageTraits];
      props.channels = ['CHANNEL_ROUTE'];
      super(props);
    }
  
    addActionListeners() {
      return [['CHANNEL_ROUTE_.*_EVENT', 'pageTraits$onRouteEvent']];
    }
  
    broadcastEvents() {
      return [['nav a', 'click']];
    }
  }
`,
      },
      {
        tabName: "AppTmplHTML",
        scriptString: `  &lt;header class='site-header'&gt;
      &lt;div class='header-content'&gt;
          &lt;h1 class='site-title'&gt;Brand Placeholder&lt;/h1&gt;
          &lt;nav class='site-nav'&gt;
              &lt;!--
                This starts an 'anonymous loop' over an array passed to this template.
                We generate an &lt;a&gt; link for each item.
              --&gt;
              {{#}}
              &lt;a
                      class='link-{{pageId}}'
                      data-channel='ROUTE'
                      data-change='{{pageId}}'
                      data-event-prevent-default='true'
                      href='/{{pageId}}'
              &gt;
                  {{pageId}}
              &lt;/a&gt;
              {{/}}
          &lt;/nav&gt;
      &lt;/div&gt;
  &lt;/header&gt;
  
  &lt;main class='stage-view'&gt;
      &lt;!--
        The active PageView is appended here, ensuring only one page
        is displayed at a time in the Single Active Page pattern.
      --&gt;
  &lt;/main&gt;
  
  &lt;footer class='site-footer'&gt;
      &lt;div class='footer-content'&gt;
          &lt;p&gt;&amp;copy; 2025 Your Company Name&lt;/p&gt;
          &lt;!-- Additional links or disclaimers could go here --&gt;
      &lt;/div&gt;
  &lt;/footer&gt;  `,
      },

      {
        tabName: "PageTraits",
        scriptString: `  import { SpyneTrait } from 'spyne';
  import { PageView } from 'components/page-view.js';
  
  export class PageTraits extends SpyneTrait {
  
    constructor(context) {
      let traitPrefix = 'pageTraits$';
      super(context, traitPrefix);
    }
  
    static pageTraits$onRouteEvent(e) {
      // Use 'home' if no route is specified
      const { change = 'home' } = e.payload.routeData;
  
      // Mark the active nav link with .selected class
      this.props.el$('nav a').setActiveItem('selected', \`.link-\${change}\`);
  
      // Retrieve the associated page data, or a 404-like object if not found
      const data = this.pageTraits$GetDataByPageId(change);
  
      // Append a new PageView in the .stage-view area,
      this.appendView(new PageView({ data }), '.stage-view');
    }
  
    /**
     * Looks up the page object by its pageId.
     */
    static pageTraits$GetDataByPageId(pageId = 'home') {
      return (
        this.props.data.find((page) => page.pageId === pageId) ||
        this.props.data[0]
      );
    }
  
    /**
     * Provides an array of page objects used by pageTraits$GetDataByPageId().
     * This could be replaced by a dynamic data source or ChannelFetch in a larger app.
     */
    static pageTraits$GetPageData() {
      return [
        {
          pageId: 'home',
          title: 'Home',
          text: 'Welcome to our starter SpyneJS application! Here you’ll find basic instructions and links to other pages.',
        },
        {
          pageId: 'features',
          title: 'Features',
          text: 'Learn about our single active page pattern, dark mode styling, and other capabilities.',
        },
        {
          pageId: 'about',
          title: 'About Us',
          text: 'We are dedicated to building intuitive single-page applications with SpyneJS. Our team is passionate about modular, maintainable code.',
        },
        {
          pageId: 'contact',
          title: 'Contact',
          text: 'Got questions or feedback? Reach out via our contact page or follow us on social media.',
        },
      ];
    }
  }
`,
      },
      {
        tabName: "PageView",
        scriptString: `  import { ViewStream } from 'spyne';

  export class PageView extends ViewStream {
    constructor(props = {}) {
      props.class = \`page-view\`;
      props.channels = [['CHANNEL_ROUTE', true]];
      props.template = \`&lt;div class=&quot;page-content&quot;&gt;
                          &lt;h2&gt;{{title}}&lt;/h2&gt;
                          &lt;p&gt;{{text}}&lt;/p&gt;
                        &lt;/div&gt;
                        \`;
      super(props);
    }
    addActionListeners() {
      return [['CHANNEL_ROUTE_CHANGE_EVENT', 'disposeViewStream']];
    }
  }

`,
      },
    ];
  }

  static codePlaygroundExamples$ViewStreamExampleTodos() {
    const props = {
      tagName: "iframe",
      width: "100%",
    };
    const iframeUrl = UtilTraits.util$GetIframeUrl(
      "example-todos/index.html?change=home",
    );

    const loadOnFrame = () => {
      this.props.el.src = iframeUrl;
      this.codePlaygroundExamples$UtilUpdateDefineHeight(360, 440);
    };
    requestAnimationFrame(loadOnFrame);

    return [
      {
        tabName: "TodoListView",
        scriptString: `  import { ViewStream, ChannelPayloadFilter } from 'spyne';
  import {TodoTraits} from 'traits/todo-traits.js';
  
  export class TodoListView extends ViewStream {
    constructor(props = {}) {
      props.channels = ['CHANNEL_UI'];
      props.id = 'todo-app';
      props.traits = [TodoTraits]
      props.nextTodoId = 1;
      props.template = \`
          &lt;h1&gt;todos&lt;/h1&gt;
          &lt;div class="todo-header"&gt;
            &lt;input
              type="text"
              class="new-todo"
              placeholder="What needs to be done?" /&gt;
              &lt;button
                class="add-todo"
                data-action="add"&gt;
                Add Todo
              &lt;/button&gt;
              <!-- add todo items here -->
            &lt;div class="items"&gt;&lt;/div&gt;
          &lt;/div&gt;\`;
      super(props);
    }
  
    broadcastEvents() {
      // The "Add Todo" button
      return [['.add-todo', 'click']];
    }
  
    // We want to respond to an "add" action from the same channel,
    addActionListeners() {
      const addActionFilter = new ChannelPayloadFilter({ action: 'add' });
      return [['CHANNEL_UI_CLICK_EVENT', 'todos$OnAddTodo', addActionFilter]];
    }
  
  
  }
`,
      },
      {
        tabName: "TodoTraits",
        scriptString: `  import { SpyneTrait } from 'spyne';
  import { TodoItemView } from 'components/todo-item-view.js';

  export class TodoTraits extends SpyneTrait {
    constructor(context) {
      // "todos$" prefix ensures consistent naming for trait methods
      let traitPrefix = 'todos$';
      super(context, traitPrefix);
    }
  
    static todos$OnAddTodo() {
      // Grab the input text
      const inputEl = this.props.el$('.new-todo').el;
      const text = inputEl.value.trim();
      if (!text) return;
  
      // Create a new item object
      const newItem = {
        todoId: \`todo-\${this.props.nextTodoId++}\`,
        text,
        completed: false,
      };
  
      // Append a new TodoItemView
      this.appendView(new TodoItemView({ data: newItem }), '.items');
  
      // Clear the input
      inputEl.value = '';
    }
  
    static todos$onItemEvent(e) {
      const { action } = e.payload;
      const actionsFnLookup = {
        edit: this.todos$StartEditMode,
        remove: this.todos$RemoveItem,
        endEdit: this.todos$EndEditMode,
      };
      const fn = actionsFnLookup[action];
      if (fn) fn.call(this);
    }
  
    static todos$StartEditMode() {
      // Toggle .is-editing class on the root .todo-item element
      this.props.el$.toggle('is-editing', true);
  
      // Initialize the edit input text
      this.props.el$('.edit-input').el.value = this.props.data.text;
    }
  
    static todos$EndEditMode() {
      this.props.el$.toggle('is-editing', false);
  
      // If we have new text, update the data
      const newVal = this.props.el$('.edit-input').el.value.trim();
      if (newVal) {
        this.props.data.text = newVal;
        this.props.el$('.todo-text').el.innerText = newVal;
      }
    }
  
    static todos$RemoveItem() {
      this.disposeViewStream();
    }
  }
`,
      },
      {
        tabName: "TodoItemView",
        scriptString: `  import { ViewStream, ChannelPayloadFilter } from 'spyne';
  import { TodoTraits } from 'traits/todo-traits.js';
  import TodoItemTmpl from './templates/todo-item.tmpl.html';
  
  export class TodoItemView extends ViewStream {
    constructor(props = {}) {
      props.channels = ['CHANNEL_UI'];
      props.class = 'todo-item';
      props.traits = [TodoTraits];
      props.template = TodoItemTmpl;
      super(props);
    }
  
    broadcastEvents() {
      // Broadcast all button clicks
      return [['button', 'click']];
    }
  
    addActionListeners() {
      // Filter so only events with the correct todoId reach onItemEvent
      const todoFilter = new ChannelPayloadFilter({
        todoId: this.props.data.todoId,
      });
      return [['CHANNEL_UI_CLICK_EVENT', 'todos$onItemEvent', todoFilter]];
    }
  }
`,
      },
      {
        tabName: "TodoItemTmpl",
        scriptString: `  &lt;p class="todo-text"&gt;{{text}}&lt;/p&gt;

  &lt;input class="edit-input" type="text" /&gt;
  
  &lt;div class="buttons-holder"&gt;
      &lt;button
              class="edit-btn"
              data-action="edit"
              data-todo-id="{{todoId}}"&gt;Edit
      &lt;/button&gt;
  
      &lt;button
              class="remove-btn"
              data-action="remove"
              data-todo-id="{{todoId}}"&gt;Remove
      &lt;/button&gt;
  
      &lt;button
              class="end-edit"
              data-action="endEdit"
              data-todo-id="{{todoId}}"&gt;Done
      &lt;/button&gt;
  &lt;/div&gt;
`,
      },
      {
        tabName: "todos.scss",
        scriptType: "scss",
        scriptString: `  /* Define some common variables for repeated usage */
  $border-radius: 4px;
  $border-color: #ddd;
  $border-color-alt: #ccc;
  $bg-color-input: #fcfcfc;
  $bg-color-button: #fff;
  $bg-color-hover: #f0f0f0;
  $text-color-heading: #999;
  
  /*
    The main container for our Todo App
  */
  #todo-app {
    background-color: azure;
    border: 1px solid $border-color;
    border-radius: $border-radius;
    padding: 1.5rem;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  
    h1 {
      margin: 0 0 1rem;
      color: $text-color-heading;
      font-weight: 100;
    }
  
    .todo-header {
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      margin-bottom: 1.25rem;
  
      /* Reuse these styles for input-like elements if needed */
      .new-todo {
        flex: 1;
        padding: 0.5rem 0.75rem;
        border: 1px solid $border-color-alt;
        border-radius: $border-radius;
        background-color: $bg-color-input;
      }
  
      /* A universal .btn class for consistent button styling */
      .btn {
        padding: 0.5rem 1rem;
        border: 1px solid $border-color;
        border-radius: $border-radius;
        background-color: $bg-color-button;
        cursor: pointer;
  
        &:hover {
          background-color: $bg-color-hover;
        }
      }
  
      /* Make .add-todo inherit from .btn for consistency */
      .add-todo {
        @extend .btn;
      }
    }
  
    .items {
      .todo-item {
        margin-bottom: 0.5rem;
        padding: 0.25rem 0;
        border-bottom: 1px dashed $border-color-alt;
  
        .todo-text {
          display: inline-block;
          margin-right: 0.5rem;
        }
  
        .edit-input {
          /* Hidden by default; toggled in .is-editing */
          display: none;
          padding: 0.35rem 0.6rem;
          margin: 0 0.5rem 0.5rem 0;
          border: 1px solid $border-color;
          border-radius: $border-radius;
          background-color: $bg-color-input;
        }
  
        .end-edit {
          /* Hidden by default; toggled in .is-editing */
          display: none;
        }
  
        .buttons-holder {
          margin-bottom: 0.5rem;
        }
  
        /*
          Let all item buttons share the .btn styling
          (instead of repeating the same hover, padding, etc.)
        */
        button {
          @extend .btn;
          padding: 0.3rem 0.6rem;
        }
  
        &.is-editing {
          .todo-text {
            display: none;
          }
          .edit-input {
            display: inline-block;
          }
          .end-edit {
            display: inline-block;
          }
        }
      }
    }
  }
`,
      },
    ];
  }

  static codePlaygroundExamples$ViewStreamInstancePrepend() {
    const embedProject = () => {
      //'css-custom-prop-color-values'
      const div = this.props.el.contentDocument.createElement("div");
      div.setAttribute("id", "embed-sdk");
      this.props.el.contentDocument.body.appendChild(div);
      const el = this.props.el.contentDocument.body.querySelector("#embed-sdk");
      //console.log('elements ',this.props.el, el);

      //https://send-info-to-channel.stackblitz.io
      sdk.embedProjectId(this.props.el, "send-info-to-channel", {
        openFile: "index.js",
        view: "preview",
      });
    };

   //console.log"IFRAME 3d ",Iframe3D)
    const props = {
      tagName: "iframe",
      width: "100%",
    };

    //new ViewStream(props).appendToDom(this.props.el.contentDocument.body);
    //this.appendViewToParentEl(new ViewStream(props));

    //const iframeUrl = "../../../static/iframes/vespa/index.html";
    const iframeUrl = UtilTraits.util$GetIframeUrl("vespa/index.html");

    const loadOnFrame = () => {
      this.props.el.src = iframeUrl;
      //console.log("IFRAME SAC ",this.props.el);
      this.codePlaygroundExamples$UtilUpdateDefineHeight(418, 526);

      this.props.el.innerHeight = 400;
    };

    requestAnimationFrame(loadOnFrame);
    //window.setTimeout(loadOnFrame, 200);

    //  embedProject();

    return [
      {
        tabName: "ThreeJSView",
        scriptString: `  
  import { ViewStream } from 'spyne';
  import { ThreejsTrait } from 'traits/threejs-trait.js';
  import { AngleUtils } from './angle-utils.js';
  
  export class ThreejsView extends ViewStream {
    constructor(props = {}) {
      props.id = 'threejs';
      props.traits = ThreejsTrait;
      props.channels = ['CHANNEL_THREEJS'];
      props.animateScooter = true;
      super(props);
    }
    onFrameUpdate(controlRads) {
      let angle =
        this.props.angleUtils.checkAngle(
          controlRads,
        );
  
      if (angle !== null) {
        let action =
          'CHANNEL_THREEJS_ANGLE_CHANGE_EVENT';
        this.sendInfoToChannel(
          'CHANNEL_THREEJS',
          angle,
          action,
        );
      }
    }
    addActionListeners() {
      return [
        [
          'CHANNEL_THREEJS_START_ANIMATION_EVENT',
          'onStartAnimation',
        ],
        [
          'CHANNEL_THREEJS_END_ANIMATION_EVENT',
          'onEndAnimation',
        ],
      ];
    }
  
    broadcastEvents() {
      return [
        ['div', 'mousedown'],
        ['div', 'mouseup'],
        ['div', 'touchstart'],
        ['div', 'touchend'],
      ];
    }
    onStartAnimation() {
      this.props.animateScooter = true;
      this.props.animateFn();
    }
    onEndAnimation() {
      this.props.animateScooter = false;
    }
  
    onRendered() {
      this.props.angleUtils = new AngleUtils();
      this.threejs$OnLoad();
    }
  }
`,
      },
      {
        tabName: "ThreeJSTrait",
        scriptString: `  import { SpyneTrait } from 'spyne';
  import { defaultTo, prop } from 'ramda';

  // Three.js core and extra modules:
  import * as THREE from 'three';
  import { FBXLoader } from
        'three/examples/jsm/loaders/FBXLoader.js';
  import { OrbitControls } from
        'three/examples/jsm/controls/OrbitControls.js';
  
  const vespaScooterURL =
    IMG_PATH + 'models/vespa_50_final_00.fbx';
  
  export class ThreejsTrait extends SpyneTrait {
    container = null;
    camera = null;
    scene = null;
    renderer = null;
    clock = new THREE.Clock();
    mixer = null;
    controls = null;
  
    constructor(context) {
      super(context, 'threejs$');
    }
  
    threejs$OnLoad() {
      // Detect whether FBXLoader is available:
      const start3d = () => {
        const threeTest = defaultTo({});
        const isLoaded =
          prop(
            'FBXLoader',
            threeTest({ FBXLoader }),
          ) !== undefined;
  
        if (isLoaded) {
          this.threejs$Initialize();
        } else {
          setTimeout(start3d, 100);
        }
      };
  
      setTimeout(start3d, 100);
    }
  
    threejs$Initialize() {
  
      const init = () => {
  
        this.container =
          document.querySelector('#threejs');
  
        // CAMERA
        this.camera = new THREE.PerspectiveCamera(
          45,
          window.innerWidth / window.innerHeight,
          1,
          2000,
        );
        this.camera.position.set(100, 200, 300);
  
        this.clock = new THREE.Clock();
  
        // SCENE
        this.scene = new THREE.Scene();
        this.scene.background = new THREE.Color(
          0x2c3e50,
        );
  
        // LIGHTS
        const ambientLight = new THREE.AmbientLight(
          0xffffff,
          0.6,
        );
        this.scene.add(ambientLight);
  
        let hemiLight = new THREE.HemisphereLight(
          0xffffff,
          0xffffff,
          0.6,
        );
        hemiLight.position.set(0, 300, 0);
        this.scene.add(hemiLight);
  
        let dirLight = new THREE.DirectionalLight(
          0xffffff,
          0.8,
        );
        dirLight.position.set(120, 300, 50);
        dirLight.castShadow = true;
        dirLight.shadow.camera.top = 380;
        dirLight.shadow.camera.bottom = -300;
        dirLight.shadow.camera.left = -320;
        dirLight.shadow.camera.right = 320;
        this.scene.add(dirLight);
  
        // GROUND MESH
        const groundMesh = new THREE.Mesh(
          new THREE.PlaneGeometry(2100, 2100),
          new THREE.MeshPhongMaterial({
            color: 0x3f5360,
            depthWrite: true,
          }),
        );
        groundMesh.rotation.x = -Math.PI / 2;
        groundMesh.receiveShadow = true;
        this.scene.add(groundMesh);
  
        // FBX LOADER
        const loader = new FBXLoader();
  
        loader.load(vespaScooterURL, (object) => {
          this.mixer = new THREE.AnimationMixer(
            object,
          );
  
          const degreesToRadians = (deg) =>
            (deg * Math.PI) / 180;
  
          // Rotate 90° around Y axis
          object.rotation.set(
            0,
            degreesToRadians(-90),
            0,
          );
  
          object.traverse((child) => {
            if (child.isMesh) {
              child.castShadow = true;
              child.receiveShadow = true;
            }
          });
  
          this.scene.add(object);
        });
  
        // RENDERER
        this.renderer = new THREE.WebGLRenderer({
          antialias: true,
        });
        this.renderer.setPixelRatio(
          window.devicePixelRatio,
        );
        this.renderer.setSize(
          window.innerWidth,
          window.innerHeight,
        );
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type =
          THREE.PCFSoftShadowMap;
        this.container.appendChild(
          this.renderer.domElement,
        );
  
        // CONTROLS
        this.controls = new OrbitControls(
          this.camera,
          this.renderer.domElement,
        );
        this.controls.target.set(0, 100, 0);
        this.controls.update();
  
        window.addEventListener(
          'resize',
          this.threejs$onWindowResize.bind(this),
          false,
        );
      };
  
      const animate = () => {
        if (this.props?.animateScooter === true) {
          requestAnimationFrame(animate);
        } else {
          // e.g. we can pass the azimuth angle to some handler
          this.onFrameUpdate?.(
            this.controls?.getAzimuthalAngle(),
          );
        }
  
        const delta = this.clock.getDelta();
        if (this.mixer) this.mixer.update(delta);
  
        this.renderer?.render(
          this.scene,
          this.camera,
        );
      };
  
      this.props.animateFn = animate;
  
      // INIT & ANIMATE
      init();
      animate();
  
      // Extra init call if desired
      const initAnim = () => animate();
      requestAnimationFrame(initAnim);
    }
  
    threejs$onWindowResize() {
      if (!this.camera || !this.renderer) return;
  
      this.camera.aspect =
        window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
  
      this.renderer.setSize(
        window.innerWidth,
        window.innerHeight,
      );
    }
  }
`,
      },
      {
        tabName: "AngleUtils",
        scriptString: `  import { lte, findIndex } from 'ramda';
  import { MathUtils } from 'three';
  
  export class AngleUtils {
    constructor() {
      this.prevNameIndex = -1;
    }
  
    /**
     * Given an angle in degrees, returns
     * a corresponding "angle name."
     */
    getAngleName(deg) {
      const angleArr = [0, 45, 135, 225, 315, 365];
      const angleNameIndex = [
        'left',
        'left',
        'back',
        'right',
        'front',
        'left',
      ];
      // Example: lte(deg) => (x) => deg <= x
      const pred = lte(deg);
      const index = findIndex(pred, angleArr);
      const angleName = angleNameIndex[index];
      console.log('deg ', { deg, angleName });
      return { index, angleName };
    }
  
    /**
     * Takes an angle in radians, converts it to degrees,
     */
    checkAngle(radians) {
      const angleDeg = MathUtils.radToDeg(radians);
      const angleNum = 180 + angleDeg; // shift by 180
      const { index, angleName } =
        this.getAngleName(angleNum);
      const isNewNameIndex =
        angleName !== this.prevNameIndex;
  
      // Update the stored angleName
      if (isNewNameIndex) {
        this.prevNameIndex = angleName;
        return { index, angleName };
      }
      return null;
    }
  }
`,
      },
      {
        tabName: "CalloutView",
        scriptString: `  import { ViewStream } from 'spyne';
  import { CalloutViewItem } from './callout-view-item.js';
  
  export class CalloutView extends ViewStream {
    constructor(props = {}) {
      props.tagName = 'section';
      props.id = 'callout-holder';
      props.channels = ['CHANNEL_THREEJS'];
      super(props);
    }
  
    addActionListeners() {
      return [
        [
          'CHANNEL_THREEJS_ANGLE_CHANGE_EVENT',
          'onAngleChangeEvent',
        ],
      ];
    }
  
    getTitle(str) {
      const titleHash = {
        left: 'LEFT PROFILE',
        front: 'FRONT VIEW',
        right: 'RIGHT PROFILE',
        back: 'CONTROLS VIEW',
      };
      return titleHash[str];
    }
  
    getListItems(str) {
      const itemsHash = {
        left: [
          'Halley',
          'Euler',
          "d'Alembert",
          'Clairaut',
          'Lagrange',
        ],
        front: [
          'Category',
          'Anti-roll bar',
          'Axle',
          'Axle track',
          'Beam axle',
        ],
        right: [
          'Multifuel',
          'Gasoline engine',
          'Hesselman engine',
          'HCCI engine',
          'Hot bulb engine',
        ],
        back: [
          'ET8 150',
          'GT 125',
          'GT 200',
          'GTS 250ie',
          'PX 125',
        ],
      };
      return itemsHash[str];
    }
  
    getCalloutData(str) {
      let title = this.getTitle(str);
      let classStr = \`details \${str}\`;
      let items = this.getListItems(str);
      return { title, classStr, items };
    }
  
    onAngleChangeEvent(e) {
      let { angleName } = e.clone();
      let data = this.getCalloutData(angleName);
      this.appendView(
        new CalloutViewItem({ data }),
      );
    }
  }
`,
      },
      {
        tabName: "CalloutViewItem",
        scriptString: `  import { ViewStream } from 'spyne';

  export class CalloutViewItem extends ViewStream {
    constructor(props = {}) {
      props.class = props.data.classStr;
      props.tagName = 'article';
      props.template = \`&lt;div class="content"&gt;
          &lt;header class="icon {{classStr}}"&gt;
          &lt;/header&gt;
          &lt;h2&gt;{{title}}&lt;/h2&gt;
            &lt;ul&gt;
              {{#items}}
              &lt;li&gt;{{.*}}&lt;/li&gt;
              {{/items}}
            &lt;/ul&gt;
          &lt;/div&gt;\`;
  
        props.channels = ['CHANNEL_THREEJS'];
        super(props);
      }
  
        addActionListeners() {
        return [
          [
            'CHANNEL_THREEJS_ANGLE_CHANGE_EVENT',
            'disposeViewStream',
          ],
        ];
      }
      }
    `,
      },
    ];
  }
}
